<template>
    <div>
        <InfoDetail infoGuid="0bc2d387-9098-477b-8c0d-96b02d616aea"></InfoDetail>
    </div>
</template>
<script>
import InfoDetail from '../../components/InfoDetail'
export default {
  components: {
    InfoDetail
  }
}
</script>
